<template>
    <MasterTemplate 
        title="หน้าจอของแต่ละกลุ่ม" 
        itemKey="groupCode"
        :headers="headers"
        :setData="setData"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        :onOpenDialog="onOpenDialog"
        >
        <template v-slot:formInput="{editedIndex, rules}">
            <v-row v-if="editedIndex == -1">
                <v-col cols="6" >
                    <v-autocomplete
                        v-model="editedItem.groupCode"
                        label="กลุ่ม"
                        :items="groups"
                        item-text="groupName"
                        item-value="groupCode"
                        :rules="[rules.required]"
                    >
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" >
                    <v-data-table
                        :headers="pageHeader"
                        :items="pageItems"
                        class="elevation-1"
                        item-key="pageGroup"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>หน้าจอ</v-toolbar-title>
                                <v-divider
                                class="mx-4"
                                inset
                                vertical
                                ></v-divider>
                                <v-spacer></v-spacer>
                                <v-dialog v-model="dialogDtl" max-width="500px">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="primary" dark class="mb-2" v-on="on">เพิ่มหน้าจอ</v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">{{formDtlTitle}}</span>
                                        </v-card-title>
                                        <v-divider
                                            class="mx-4"
                                            inset
                                            style="padding-top:10px;"
                                            ></v-divider>

                                        <v-card-text>
                                            <v-container>
                                                <v-form ref="formDtl" lazy-validation>
                                                      <v-row >
                                                        <v-col cols="12" >
                                                            <v-autocomplete
                                                                v-model="page.pageCode"
                                                                menu-props="auto"
                                                                label="หน้าจอ"
                                                                :items="pages"
                                                                item-text="pageDisplay"
                                                                item-value="pageCode"
                                                                :rules="[rules.required]"
                                                            >
                                                            </v-autocomplete>
                                                        </v-col>
                                                    </v-row>
                                                    <!--
                                                    <v-row >
                                                        <v-col cols="12" >
                                                            <v-autocomplete
                                                                v-model="pageFunctionItem"
                                                                :items="page.pageFunction"
                                                                dense
                                                                chips
                                                                small-chips
                                                                label="สิทธ์การใช้งาน"
                                                                multiple
                                                                item-text="functionName"
                                                                item-value="functionName"
                                                                :rules="[rules.required]"
                                                            ></v-autocomplete>
                                                        </v-col>
                                                    </v-row>
                                                    -->
                                                </v-form>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDtl">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="saveDtl">Save</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-icon
                                small
                                class="mr-2"
                                @click="editPageItem(item)"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                small
                                @click="deletePageItem(item)"
                            >
                                delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </template>
    </MasterTemplate>
</template>

<script>
/* eslint-disable */
import MasterTemplate from '@/components/MasterTemplate'
import {listPageGroup, listAvaliablePageGroup, listPageByGroup, insert, update, deletePageGroup} from '@/api/page-group-api.js'
import { listPageForAdd} from '@/api/master/page-api.js'
export default {
    name: 'PageGroup',
    components: {
        MasterTemplate
    },
    computed: {
      formDtlTitle() {
        return this.editedDtlIndex === -1 ? 'เพิ่มหน้าจอ' : 'แก้ไขหน้าจอ';
      }
    },
    watch: {
        dialogDtl(val) {
            if (val) {
                this.onOpenDtlDialog();
            }
        },
        'page.pageCode': function(newVal) {
            //if (!newVal) return;
            let tmp = this.pages.filter(x => x.pageCode == newVal);
            if (!tmp || tmp.length <= 0) {
                return;
            }
            let p = tmp[0];
            this.page.pageFunction = p.pageFunction;
            this.page.pageName = p.pageName;
            this.page.pageDisplay = p.pageCode + ':' + p.pageName;
            this.pageFunctionItem = [];
        }
    },
    data: () => ({
        headers: [
            {text: 'รหัสกลุ่ม', value: 'groupCode'},
            {text: 'ชื่อกลุ่ม', value: 'groupName'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        pageHeader: [
            {text: 'รหัสหน้าจอ', value: 'pageCode'},
            {text: 'ชื่อหน้าจอ', value: 'pageName'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        editedItem: {
            pageGroupId: '-1',
            groupCode: '',
            pages: [{
                pageCode: '',
                pageFunction: [{
                    functionName: '',
                    enable: false
                }]
            }]
        },
        groups: [],
        pages: [],
        pageItems: [],
        page: '',
        pageFunctionItem: [],
        editedDtlIndex: -1,
        dialogDtl: false,
        itemKey: ''
    }),
    methods: {
        closeDtl () {
            this.editedDtlIndex = -1;
            this.dialogDtl = false;
            setTimeout(() => {
                this.$refs.formDtl.resetValidation();
                this.page = Object.assign({}, new Object());
                this.pageFunctionItem = [];
            }, 300)
        },
        saveDtl() {
            if (!this.$refs.formDtl.validate()) {
                return
            }
             /*
            var _this = this;
            this.page.pageFunction.forEach(function(val, idx) {
                val.enable = false;
            });
           
            this.pageFunctionItem.forEach(function(val, idx) {
                if (!val || ! _this.page.pageFunction) return;
                _this.page.pageFunction.filter(x => x.functionName == val)[0].enable = true;
            });
            console.log(this.pageItems);
            */
           console.log(this.page);
            if (this.editedDtlIndex != -1) {
                this.pageItems.splice(this.editedDtlIndex, 1, this.page);
            } else {
                this.pageItems.push(this.page);
            }
            this.closeDtl();
        },
        listData() {
            return listPageGroup();
        },
        deleteData(item) {
            return deletePageGroup(item.groupCode);
        },
        insertData() {
            this.editedItem.pages = this.pageItems;
            return insert(this.editedItem);
        },
        updateData() {
            this.editedItem.pages = this.pageItems;
            return update(this.editedItem);
        },
        getItemName(item) {
            return item.groupName;
        },
        setData(item) {
            this.editedItem = item;
            this.pageItems = item.pages;
        },
        onOpenDialog() {
            listAvaliablePageGroup().then(rs => {
                this.groups = rs;
            });
        },
        editPageItem(item) {
            let _this = this;
            this.editedDtlIndex = this.pageItems.indexOf(item);
            this.page = Object.assign({}, item);
            this.page.pageFunction.forEach(function(val, idx) {
                if (val.enable == true) {
                    _this.pageFunctionItem.push(val.functionName);
                }
            });
            this.dialogDtl = true;
        },
        deletePageItem(item) {
            const index = this.pageItems.indexOf(item);
            this.pageItems.splice(index, 1);
        },

        onOpenDtlDialog() {
            //if (this.editedDtlIndex != -1) return;
            if (this.pageItems == null || this.pageItems == 'undefined') {
                this.pageItems = [];
            }
            
            listPageForAdd().then(rs => {
                this.pages = rs;
                if (rs) {
                    this.pages.forEach(e => {
                        e.pageDisplay = e.pageCode + ':' + e.pageName;
                    });

                    this.pages = rs.filter(x => {
                        if (!this.pageItems || this.pageItems.length == 0) return true;
                        return this.pageItems.filter(e => e.pageCode === x.pageCode).length == 0;
                    })
                }
                this.page = Object.assign({}, new Object());
            });
        }
    },
    mounted() {

    }

}
</script>